import React from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormControlLabel, Checkbox } from 'edenred-ui';

import { FormFields } from '@epi-forms/helpers';
import { AllowEmployeeReportsCheckboxProps } from '@epi-models/forms/Controls';

export function AllowEmployeeReportsCheckbox({
  readOnly
}: AllowEmployeeReportsCheckboxProps) {
  const name = FormFields.AllowEmployeeReports;
  const { control } = useFormContext();
  const { t } = useTranslation();

  const {
    field: { value, onChange: setValue }
  } = useController({
    name,
    control
  });

  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={!!value}
          id={name}
          onChange={setValue}
          disabled={readOnly}
        />
      }
      label={t('controls.allow_employee_reports_label')}
    />
  );
}
